import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

export const purestorage: GetCustomerCopyFunc = () => {
  return {
    displaySessionLimit: false,
  }
}
